var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0829 9.96899H11.4448C10.6302 9.96899 9.96973 10.6294 9.96973 11.4441V18.0821C9.96973 18.8968 10.6302 19.5572 11.4448 19.5572H18.0829C18.8975 19.5572 19.558 18.8968 19.558 18.0821V11.4441C19.558 10.6294 18.8975 9.96899 18.0829 9.96899Z",
    stroke: "currentColor",
    strokeWidth: 1.80626,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01883 14.3946H6.28127C5.89004 14.3946 5.51484 14.2392 5.2382 13.9626C4.96157 13.686 4.80615 13.3108 4.80615 12.9195V6.28151C4.80615 5.89029 4.96157 5.51509 5.2382 5.23845C5.51484 4.96181 5.89004 4.8064 6.28127 4.8064H12.9193C13.3105 4.8064 13.6857 4.96181 13.9624 5.23845C14.239 5.51509 14.3944 5.89029 14.3944 6.28151V7.01907",
    stroke: "currentColor",
    strokeWidth: 1.80626,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cf8ef095a62cda966ad38e8eb901e424.svg";
export { ForwardRef as ReactComponent };